var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightAroShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8374 8.42188C9.07178 8.1875 9.07178 7.85938 8.8374 7.625L1.99365 0.6875C1.75928 0.453125 1.38428 0.453125 1.19678 0.6875L0.259277 1.625C0.0249023 1.8125 0.0249023 2.1875 0.259277 2.42188L5.79053 8L0.259277 13.625C0.0249023 13.8594 0.0249023 14.1875 0.259277 14.4219L1.19678 15.3594C1.38428 15.5938 1.75928 15.5938 1.99365 15.3594L8.8374 8.42188Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightAroShop);
export default __webpack_public_path__ + "static/media/rightAroShop.1452ba860a25af5baa57aee54ff2d14e.svg";
export { ForwardRef as ReactComponent };